import * as yup from 'yup';

import { validators } from './utilities';

/**
 * Validation schema for Parcel Rate Request form fields.
 * Forked from batchFieldSchema.ts — no targetedCarriers (its backing SCAC list is LTL-only and
 * was never functional for parcel; carrier filtering is deferred this phase), no
 * returnLiveContractRates/returnProposalContractRates/returnVolumeRates (LTL contract-rate
 * concepts, no analog in the new ParcelQuoteOptions contract).
 * Maps to RateQuality's ParcelShipmentDataToRate.cs.
 */
export const parcelFieldSchema = {
  // Results file name
  fileName: yup.string().max(10, 'File name prefix must be 10 characters or fewer'),

  // Shipment data upload (Excel file with shipment rows)
  shipmentsFileUpload: yup
    .array()
    .of(yup.mixed<File>().required('File is required'))
    .required('Shipment file is required'),

  // BG Rating Account(s) - up to 4, same as Batch Rate; RateQuality fans out one rate
  // request per account per shipment (see BS.RateQuality-1's ShipmentsParcelRateOrchestrator)
  accounts: yup
    .array()
    .of(
      yup.object({
        name: yup.string().required(),
        enterpriseID: yup.number().required(),
        accountNumber: yup.string().required(),
      })
    )
    .min(1, 'An account is required')
    .max(4, 'Maximum of 4 accounts allowed')
    .required('An account is required'),

  // Rate return option - the only ParcelQuoteOptions flag that's conditional (maps to SkipMarkup).
  // Defaults unchecked for Parcel Rate specifically (unlike Batch Rate/Rate Compare, which default checked).
  returnCustomerRates: yup.boolean().default(false),

  // Which carrier(s) to request rates for. Both default checked (rate both), matching
  // pre-carrier-selection behavior — BS.ParcelAPI's own credential store still determines which
  // of the requested carrier(s) the account is actually configured for.
  rateUps: yup.boolean().default(true),
  rateFedEx: yup.boolean().default(true),

  // Notification emails
  notifyEmails: yup
    .array(
      yup
        .object({
          value: validators.blugraceEmail.required(),
        })
        .required()
    )
    .required(),
};
